/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_TermsInputs */

const en_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const de_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGB`)
};

const fr_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions`)
};

const es_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos`)
};

const it_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini`)
};

const nl_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorwaarden`)
};

const pl_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulamin`)
};

const fi_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käyttöehdot`)
};

const da_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vilkår`)
};

const sv_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villkor`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Landing_Footer_TermsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_terms = /** @type {((inputs?: Landing_Footer_TermsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_TermsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_terms(inputs)
	if (locale === "fr") return fr_landing_footer_terms(inputs)
	if (locale === "es") return es_landing_footer_terms(inputs)
	if (locale === "it") return it_landing_footer_terms(inputs)
	if (locale === "nl") return nl_landing_footer_terms(inputs)
	if (locale === "pl") return pl_landing_footer_terms(inputs)
	if (locale === "fi") return fi_landing_footer_terms(inputs)
	if (locale === "da") return da_landing_footer_terms(inputs)
	if (locale === "sv") return sv_landing_footer_terms(inputs)
	return en_landing_footer_terms(inputs)
});